const VIDEO_EDIT_USER_KEY = "video_edit_user"

export function getLoginUser() {
  const str = localStorage.getItem(VIDEO_EDIT_USER_KEY)
  if (!str) {
    return null
  }
  try {
    return JSON.parse(str)
  } catch (e) {
    return null
  }
}

export function setLoginUser(user) {
  localStorage.setItem(VIDEO_EDIT_USER_KEY, JSON.stringify(user))
}

export function clearLoginUser() {
  localStorage.removeItem(VIDEO_EDIT_USER_KEY)
}

export function isLoggedIn() {
  const user = getLoginUser()
  return !!(user && user.phoneNumber && user.token)
}
